import { pickBy } from 'lodash-es';
import { getCookie } from './cookies';
import { getHrefWithoutOrigin, jsonToFormData } from './helpers';

export const getIdFromShopifyGraphQLId = (input: string) => {
  let inputStr = input;
  try {
    inputStr = window.atob(input);
  } catch {
    // console.error(`getIdFromShopifyGraphQLId failed 'atob' for '${input}' ${inputStr}`);
  }
  try {
    const extractedId = extractProductIdFromDecodedGraphQLId(inputStr);
    if (!extractedId) console.log('Failed to extract Shopify Id', { inputStr });
    return extractedId ?? inputStr;
  } catch {
    console.error(`getIdFromShopifyGraphQLId failed for '${input}'`);
    return input;
  }
};

export const extractProductIdFromDecodedGraphQLId = (decodedGraphQLId: string) => {
  const REGEX = /gid:\/\/shopify\/.+\/(.*)/;
  const [, id] = decodedGraphQLId.match(REGEX) || [];
  return id;
};

// ? [REVISIT] move to shared folder
export type ShopifyResourceName = 'Product' | 'Collection' | 'ProductVariant';

export const discountCodeAttachedToCart = () => {
  return getCookie('discount_code')?.toUpperCase() || null;
};

export const generateShopifyGraphQLId = (resource: ShopifyResourceName, id: string) =>
  window.btoa(`gid://shopify/${resource}/${id}`);

// Case-insensitive tag comparison, useful for a user-inputted tag
export const tagsIncludesTag = (tags: string[], tag: string) => {
  const trimmedTag = tag.trim().toLowerCase();
  return tags.some((tag) => tag.toLowerCase() === trimmedTag);
};

export const changeLocalization = async ({
  countryCode,
  localeCode,
  shouldFollowRedirect = true,
  onSuccessCallback,
}: {
  countryCode?: string | undefined;
  localeCode?: string | undefined;
  shouldFollowRedirect?: boolean;
  onSuccessCallback?: () => void;
}) => {
  // ? consider adding sanity check to avoid logic is current state matches desired state

  // follows Shopify's pattern to swap localization
  // - pickBy removes nil (null or undefined) keys from an object
  const jsonData = pickBy(
    {
      form_type: 'localization',
      _method: 'put',
      return_to: encodeURIComponent(getHrefWithoutOrigin()),
      country_code: countryCode,
      locale_code: localeCode,
    },
    (i) => i
  ) as Record<string, string>;

  const formData = jsonToFormData(jsonData);

  try {
    const response = await fetch('/localization', {
      method: 'POST',
      body: formData,
      redirect: 'follow', // To handle 302 redirects
    });
    if (response.ok) {
      onSuccessCallback?.();
    }
    if (response.url && shouldFollowRedirect) {
      window.location.href = response.url;
    } else {
      const result = await response.json();
      return result;
    }
  } catch (error) {
    console.error('Error submitting form:', error);
  }
};
